<template>
  <validation-provider
    v-slot="{ errors }"
    :rules="rules"
    mode="eager"
    :name="label"
  >
    <v-text-field
      ref="input"
      v-model="searchPhrase"
      outlined
      dense
      clearable
      v-bind="$attrs"
      :error-messages="errors"
      :label="label"
      :maxlength="maxlength"
      :placeholder="placeholder"
      @click:clear.prevent="resetFilter"
      @change="onChangeInput"
      @keyup.enter="$event.target.blur()"
    >
      <template #label>
        <slot name="label" />
      </template>
      <template v-if="showMethod" v-slot:prepend-inner>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" @click="iconClick">
              {{ icon }}
            </v-icon>
          </template>
          {{ iconHint }}
        </v-tooltip>
      </template>
    </v-text-field>
  </validation-provider>
</template>

<script>
export default {
  model: {
    prop: "model",
    event: "changeFilter"
  },
  props: {
    model: {
      default: null,
      type: Object
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: null
    },
    maxlength: {
      type: Number,
      default: 30
    },
    output: {
      type: String,
      default: null
    },
    validator: {
      type: Function,
      default: null
    },
    rules: {
      type: [String, Object],
      default: ""
    },
    tmpErrorDuration: {
      type: Number,
      default: 2000
    },
    showMethod: {
      type: Boolean,
      default: true
    },
    defaultLike: {
      type: Boolean,
      default: null
    },
    defaultInverse: {
      type: Boolean,
      default: false
    },
    disableLike: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const defLike =
      this.defaultLike == null ? this.showMethod : this.defaultLike;
    return {
      temporaryError: null,
      searchPhrase: null,
      inverse: this.defaultInverse,
      like: this.disableLike ? false : defLike
    };
  },
  computed: {
    icon() {
      const { like, inverse } = this;
      let icon = null;
      if (!like && !inverse) icon = "mdi-equal";
      else if (!like && inverse) icon = "mdi-not-equal-variant";
      else if (like && !inverse) icon = "mdi-approximately-equal";
      else if (like && inverse) icon = "mdi-approximately-equal-box";
      return icon;
    },
    iconHint() {
      const { like, inverse } = this;
      let iconHint = null;
      if (!like && !inverse) iconHint = "Поиск равенством";
      else if (!like && inverse) iconHint = "Поиск неравенством";
      else if (like && !inverse) iconHint = "Поиск методом Like";
      else if (like && inverse) iconHint = "Поиск инверсией Like";
      return iconHint;
    }
  },
  watch: {
    model(newV) {
      this.onChangeModel(newV);
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.onChangeModel(this.model);
      this.$emit("init");
    },
    getOutput() {
      const { searchPhrase, label } = this;
      if (!searchPhrase) return null;
      let output = label ? `${label}: ` : "";
      output += searchPhrase;
      return output;
    },
    onChangeModel(model) {
      if (model) {
        const { value, like, inverse } = model;
        this.like = like || this.like;
        this.inverse = inverse || this.inverse;
        this.searchPhrase = value || this.searchPhrase;
      } else {
        this.resetFilter();
      }
      this.setOutput();
    },
    onChangeInput() {
      const { searchPhrase, validator, label } = this;
      let filter = searchPhrase
        ? { ...this.modelFactory(), value: searchPhrase }
        : null;

      if (typeof validator === "function") {
        const { result, message } = validator(searchPhrase, label);
        if (result !== true) {
          if (message) this.showTemporaryError(message);
          this.resetFilter();
          return;
        }
      }

      this.setFilter(filter);
      this.$emit("apply");
    },
    showTemporaryError(error) {
      this.temporaryError = [error];
      setTimeout(() => (this.temporaryError = null), this.tmpErrorDuration);
    },
    setFilter(filter) {
      this.$emit("changeFilter", filter);
      this.setOutput();
    },
    setOutput() {
      this.$emit("update:output", this.getOutput());
    },
    modelFactory() {
      return {
        value: null,
        like: this.like,
        inverse: this.inverse
      };
    },
    iconClick() {
      const { like, inverse } = this;
      if (this.disableLike) {
        this.inverse = !this.inverse;
      } else if (!like && !inverse) {
        this.inverse = true;
      } else if (!like && inverse) {
        this.inverse = false;
        this.like = true;
      } else if (like && !inverse) {
        this.inverse = true;
      } else if (like && inverse) {
        this.inverse = false;
        this.like = false;
      }
      if (this.searchPhrase) this.onChangeInput();
    },
    resetFilter() {
      const defLike =
        this.defaultLike == null ? this.showMethod : this.defaultLike;
      this.inverse = false;
      this.like = this.disableLike ? false : defLike;
      this.searchPhrase = null;
      this.setFilter(null);
    }
  }
};
</script>
